import { useQuery } from '@tanstack/react-query';

import { ActivityLogFieldValue } from '../../models/activty-log.model';

import API from '../../services/api';

/** The full before/after of a large field stored as a sha256: digest. */
export default function useActivityLogFieldQuery(
    source: { activityId: number; firstActivityId: number },
    field: string,
    enabled: boolean,
) {
    return useQuery<ActivityLogFieldValue>({
        queryKey: [
            'activity_logs',
            'field',
            source.activityId,
            source.firstActivityId,
            field,
        ],
        queryFn: async () => {
            const { data } = await API.getActivityLogField(
                source.activityId,
                field,
                source.firstActivityId,
            );
            return data;
        },
        enabled,
        // History doesn't change: fetch once.
        staleTime: Infinity,
        retry: false,
        // The caller shows its own inline error.
        meta: { skipGlobalErrorToast: true },
    });
}
